﻿import $ from 'jquery';
import 'datatables.net-dt';
import 'datatables.net-responsive-dt';
import { ColumnSelector } from 'datatables.net-dt';
import { bindSelectAllCheckboxToPagedList } from '../elementUtils';

// Module augmentation to fix missing property validation
// Module augmentation to fix missing property validation
declare module 'datatables.net' {
    namespace DataTables {
        interface ColumnDefsSettings {
            responsivePriority?: number;
        }

        interface LanguagePaginateSettings {
            first?: string;
            last?: string;
        }
    }
}

// Page limit on each page for table pagination
const PAGE_LIMIT = 10;
let selectedIdpFilesToDownload: string[] = [];
let selectedDownloadedIdpFilesToUndo: string[] = [];

// Holds the configuration of making tables as datatables
export const DataTablesHelper = {
    SoftwareDevelopmentForum: function () {
        $(document).ready(function () {

            $('#sdf-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this, '#sdf-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 2, target: 0 },
                    { responsivePriority: 4, target: 1, className: 'not-mobile' },
                    { responsivePriority: 1, target: 2 },
                    { responsivePriority: 5, target: 3, className: 'not-mobile' },
                    { responsivePriority: 6, target: 4, className: 'not-mobile' },
                    { responsivePriority: 3, target: 5, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    CookiePolicy: function () {
        $(document).ready(function () {
            $('#cookies-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#cookies-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0 },
                    { responsivePriority: 2, target: 1 },
                    { responsivePriority: 4, target: 2, className: 'not-mobile' },
                    { responsivePriority: 5, target: 3, className: 'not-mobile' },
                    { responsivePriority: 3, target: 4, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    ManageLRSDetailsTable: function () {
        $(document).ready(function () {
            $('#manage-LRS-details-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#manage-LRS-details-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 3, target: 1, className: 'min-tablet-l' },
                    { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 6, target: 4, className: 'min-tablet-l' },
                    { responsivePriority: 7, target: 5, className: 'min-tablet-l' },
                    { responsivePriority: 8, target: 6, className: 'min-tablet-l' },
                    { responsivePriority: 9, target: 7, className: 'min-tablet-l' },
                    { responsivePriority: 2, target: 8, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },
    PackagedFiles: function () {
        $(document).ready(function () {
            // @ts-ignore
            if ($.fn.DataTable.isDataTable("#packaged-files-table")) {
                return;
            }
            $('#packaged-files-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#packaged-files-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 2, target: 0, className: 'all' },
                    { responsivePriority: 1, target: 1, className: 'all' },
                    { responsivePriority: 4, target: 2, className: 'not-mobile' },
                    { responsivePriority: 6, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 7, target: 4, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 5, className: 'not-mobile' },
                    { responsivePriority: 3, target: 6, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },
    ViewSchoolEmails: function () {
        $(document).ready(function () {

            $('#view-school-emails-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#view-school-emails-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0 },
                    { responsivePriority: 2, target: 1 },
                    { responsivePriority: 4, target: 2, className: 'not-mobile' },
                    { responsivePriority: 3, target: 3, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },
    XSLTTestingTable: function (allFilesSelected: boolean) {
        $(document).ready(function () {
            if (allFilesSelected) {
                $('#xslt-testing-table').DataTable({
                    lengthChange: false,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: false,
                    autoWidth: false,
                    drawCallback: function () {
                        hideDatatable(this,'#xslt-testing-table');
                    },
                    // Set priority to columns
                    // The lower the responsivePriority value the higher the priority
                    // Target - column
                    columnDefs: <any>[
                        { responsivePriority: 1, target: 0, className: 'all' },
                        { responsivePriority: 2, target: 1, className: 'all' },
                        { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                        { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                        { responsivePriority: 6, target: 4, className: 'min-tablet-l' },
                        { responsivePriority: 7, target: 5, className: 'min-tablet-l' },
                        { responsivePriority: 8, target: 6, className: 'min-tablet-l' },
                        { responsivePriority: 3, target: 7, className: 'dtr-control', orderable: false, targets: -1 }
                    ],
                    responsive: {
                        details: {
                            type: 'column',
                            target: -1,
                            // TypeScript is throwing an error, even though it still works when ignoring the error
                            // Renderer - how the expanded section is displayed
                            // @ts-ignore
                            renderer: function (api, rowIdx, columns) {
                                const data = $.map(columns, function (col, i) {
                                    // Markup of how the expanded section is rendered
                                    return col.hidden ?
                                        '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                        '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                        '<td class="table__data-row--child">' + col.data + '</td>' +
                                        '</tr>' :
                                        '';
                                }).join('');

                                return data ?
                                    $('<table/>').append(data) :
                                    false;
                            }
                        }
                    }
                });
            }
            else {
                $('#xslt-testing-table').DataTable({
                    lengthChange: false,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: false,
                    autoWidth: false,
                    drawCallback: function () {
                        hideDatatable(this,'#xslt-testing-table');
                    },
                    // Set priority to columns
                    // The lower the responsivePriority value the higher the priority
                    // Target - column
                    columnDefs: <any>[
                        { responsivePriority: 1, target: 0, className: 'all' },
                        { responsivePriority: 2, target: 1, className: 'all' },
                        { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                        { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                        { responsivePriority: 6, target: 4, className: 'min-tablet-l' },
                        { responsivePriority: 7, target: 5, className: 'min-tablet-l' },
                        { responsivePriority: 3, target: 6, className: 'dtr-control', orderable: false, targets: -1 }
                    ],
                    responsive: {
                        details: {
                            type: 'column',
                            target: -1,
                            // TypeScript is throwing an error, even though it still works when ignoring the error
                            // Renderer - how the expanded section is displayed
                            // @ts-ignore
                            renderer: function (api, rowIdx, columns) {
                                const data = $.map(columns, function (col, i) {
                                    // Markup of how the expanded section is rendered
                                    return col.hidden ?
                                        '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                        '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                        '<td class="table__data-row--child">' + col.data + '</td>' +
                                        '</tr>' :
                                        '';
                                }).join('');

                                return data ?
                                    $('<table/>').append(data) :
                                    false;
                            }
                        }
                    }
                });
            }
        })
    },

    SoftwareDevelopmentForumRecentFiles: function () {
        $(document).ready(function () {
            $('#sdf-recent-files').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#sdf-recent-files');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 2, target: 0, className: 'all' },
                    { responsivePriority: 1, target: 1, className: 'all' },
                    { responsivePriority: 6, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 3, className: 'not-mobile' },
                    { responsivePriority: 4, target: 4, className: 'not-mobile' },
                    { responsivePriority: 3, target: 5, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    /**
     *
     * @param headingTranslations Translations for table headings when collapsing table for mobile
     */
    XsltTestingToolValidationReport: function (headingTranslations: { number: string, type: string, message: string, keyFields: string }) {
        // Validation failures table generated by XSLT doesn't contain titles in the <thead> so titles must be manually set
        /** Mapping of column indexes to titles */
        const titleLookup: { [key: number]: string } = {
            0: headingTranslations.number,
            1: headingTranslations.type,
            2: headingTranslations.message,
            3: headingTranslations.keyFields
        };

        $('.xslt-file-details .filelist').DataTable({
            lengthChange: false,
            paging: false,
            searching: false,
            info: false,
            ordering: false,
            autoWidth: false,
            drawCallback: function () {
                hideDatatable(this,'.xslt-file-details .filelist');
            },
            // Set priority to columns
            // The lower the responsivePriority value the higher the priority
            // Target - column
            columnDefs: <any>[
                { responsivePriority: 1, target: 0 }, // Number column
                { responsivePriority: 3, target: 1, className: 'min-tablet-l' }, // Type column
                { responsivePriority: 2, target: 2 }, // Message column
                { responsivePriority: 4, target: 3, className: 'min-tablet-l' }, // Keyfields column
            ],
            responsive: {
                details: {
                    type: 'column',
                    target: 2,
                    // TypeScript is throwing an error, even though it still works when ignoring the error
                    // Renderer - how the expanded section is displayed
                    // @ts-ignore
                    renderer: function (api, rowIdx, columns) {

                        const data = $.map(columns, function (col, i: number) {
                            // Markup of how the expanded section is rendered
                            return col.hidden ?
                                '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                '<td class="table__data-row--child">' + titleLookup[i] + ':' + '</td> ' +
                                '<td class="table__data-row--child">' + col.data + '</td>' +
                                '</tr>'
                                : '';
                        }).join('');

                        return data ?
                            $('<table/>').append(data) :
                            false;
                    }
                }
            }
        })

    },

    ManageUsersTable: function (GenericUser: boolean) {
        $(document).ready(function () {
            if (GenericUser) {
                $('#manage-users-table').DataTable({
                    lengthChange: false,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: false,
                    autoWidth: false,
                    drawCallback: function () {
                        hideDatatable(this,'#manage-users-table');
                    },
                    // Set priority to columns
                    // The lower the responsivePriority value the higher the priority
                    // Target - column
                    columnDefs: <any>[
                        { responsivePriority: 1, target: 0, className: 'all' },
                        { responsivePriority: 2, target: 1, className: 'all' },
                        { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                        { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                        { responsivePriority: 6, target: 4, className: 'min-tablet-l' },
                        { responsivePriority: 7, target: 5, className: 'min-tablet-l' },
                        { responsivePriority: 3, target: 6, className: 'dtr-control', orderable: false, targets: -1 }
                    ],
                    responsive: {
                        details: {
                            type: 'column',
                            target: -1,
                            // TypeScript is throwing an error, even though it still works when ignoring the error
                            // Renderer - how the expanded section is displayed
                            // @ts-ignore
                            renderer: function (api, rowIdx, columns) {
                                const data = $.map(columns, function (col, i) {
                                    // Markup of how the expanded section is rendered
                                    return col.hidden ?
                                        '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                        '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                        '<td class="table__data-row--child">' + col.data + '</td>' +
                                        '</tr>' :
                                        '';
                                }).join('');

                                return data ?
                                    $('<table/>').append(data) :
                                    false;
                            }
                        }
                    }
                });
            }
            else {
                $('#manage-users-table').DataTable({
                    lengthChange: false,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: false,
                    autoWidth: false,
                    drawCallback: function () {
                        hideDatatable(this,'#manage-users-table');
                    },
                    // Set priority to columns
                    // The lower the responsivePriority value the higher the priority
                    // Target - column
                    columnDefs: <any>[
                        { responsivePriority: 1, target: 0, className: 'all' },
                        { responsivePriority: 2, target: 1, className: 'all' },
                        { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                        { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                        { responsivePriority: 3, target: 4, className: 'dtr-control', orderable: false, targets: -1 }
                    ],
                    responsive: {
                        details: {
                            type: 'column',
                            target: -1,
                            // TypeScript is throwing an error, even though it still works when ignoring the error
                            // Renderer - how the expanded section is displayed
                            // @ts-ignore
                            renderer: function (api, rowIdx, columns) {
                                const data = $.map(columns, function (col, i) {
                                    // Markup of how the expanded section is rendered
                                    return col.hidden ?
                                        '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                        '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                        '<td class="table__data-row--child">' + col.data + '</td>' +
                                        '</tr>' :
                                        '';
                                }).join('');

                                return data ?
                                    $('<table/>').append(data) :
                                    false;
                            }
                        }
                    }
                });
            }
        })
    },

    AdminPanelIPTable: function () {
        $(document).ready(function () {
            $('#admin-panel-ip-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#admin-panel-ip-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 3, target: 1, className: 'min-tablet-l' },
                    { responsivePriority: 2, target: 2, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    ManageNews: function () {
        $(document).ready(function () {

            $('#manage-news-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#manage-news-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0 },
                    { responsivePriority: 2, target: 1, className: 'max-tablet-p' },
                    { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 3, target: 4, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });

            // Call to initially hide the news title
            hideColumn('(max-width: 768px)', document.querySelector('#manage-news-table'), 1);

            // Setup media query listener to toggle hiding the news title column from the datatable config depending on screen size
            const mql = window.matchMedia('(max-width: 768px)');

            mql.onchange = (e) => {
                hideColumn('(max-width: 768px)', document.querySelector('#manage-news-table'), 1);
            }
        })
    },

    RecentUserActions: function () {
        $(document).ready(function () {
            $('#recent-user-actions-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#recent-user-actions-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 2, target: 1, className: 'all' },
                    { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 3, target: 3, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    ManageSchoolsTable: function () {
        $(document).ready(function () {
            $('#manage-schools-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: true,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#manage-schools-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 2, target: 1, className: 'all' },
                    { responsivePriority: 6, target: 2, className: 'min-tablet-p' },
                    { responsivePriority: 7, target: 3, className: 'min-tablet-p' },
                    { responsivePriority: 8, target: 4, className: 'min-tablet-p' },
                    { responsivePriority: 9, target: 5, className: 'min-tablet-p' },
                    { responsivePriority: 10, target: 6, className: 'min-tablet-p' },
                    { responsivePriority: 11, target: 7, className: 'min-tablet-p' },
                    { responsivePriority: 12, target: 8, className: 'min-tablet-p' },
                    { responsivePriority: 3, target: 9, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    breakpoints: [
                        { name: 'min-tablet-p', width: 767 }
                    ],
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + (col.columnIndex == 8 ? "" : col.title) + '</td> ' +
                                    '<td class="table__data-row--child">' + (col.data === "" ? '<span class="material-icons">close</span>' : col.data) + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },
    GenericFileList: function (showClaimed: boolean) {
        $(document).ready(function () {
            $('#generic-file-list').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: true,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#generic-file-list');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 2, target: 1, className: 'all' },
                    { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 6, target: 4, className: 'all' },
                    { responsivePriority: 7, target: 5, className: 'min-tablet-l' },
                    { responsivePriority: 3, target: 6, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + (col.columnIndex == 5 && !showClaimed ? "" : col.title) + '</td> ' +
                                    '<td class="table__data-row--child">' + (col.columnIndex == 5 && !showClaimed ? "" : col.data) + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    GenericFileListFromSchool: function (showClaimed: boolean) {
        $(document).ready(function () {
            $('#school-generic-file-list').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: true,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#school-generic-file-list');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 5, target: 1, className: 'min-tablet-l' },
                    { responsivePriority: 6, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 2, target: 3, className: 'all' },
                    { responsivePriority: 7, target: 4, className: 'desktop' },
                    { responsivePriority: 8, target: 5, className: 'desktop' },
                    { responsivePriority: 4, target: 6, className: 'all' },
                    { responsivePriority: 9, target: 7, className: 'desktop' },
                    { responsivePriority: 3, target: 8, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + (col.columnIndex == 7 && !showClaimed ? "" : col.title) + '</td> ' +
                                    '<td class="table__data-row--child">' + (col.columnIndex == 7 && !showClaimed ? "" : col.data) + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    GenericFileMultipleProvider: function () {
        $(document).ready(function () {
            $('#generic-file-list').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: true,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#generic-file-list');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 2, target: 1, className: 'all' },
                    { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 6, target: 4, className: 'min-tablet-l' },
                    { responsivePriority: 7, target: 5, className: 'all' },
                    { responsivePriority: 3, target: 6, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    AzureResourcesConnectionStatus: function () {
        $(document).ready(function () {

            $('#azure-resources-connection-status-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#azure-resources-connection-status-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0 },
                    { responsivePriority: 2, target: 1, className: 'not-mobile' },
                    { responsivePriority: 4, target: 2, className: 'not-mobile' },
                    { responsivePriority: 3, target: 3, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    DownloadULNsTable: function () {
        $(document).ready(function () {
            $('#download-ulns-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#download-ulns-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 2, target: 0, className: 'all' },
                    { responsivePriority: 1, target: 1, className: 'all' },
                    { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 3, target: 4, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    AdminPanelQueuedFiles: function () {
        $(document).ready(function () {
            $('#queued-files-table')?.DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#queued-files-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 2, target: 0, className: 'min-tablet-l' },
                    { responsivePriority: 1, target: 1, className: 'min-tablet-l' },
                    { responsivePriority: 6, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 1, target: 3, className: 'all' },
                    { responsivePriority: 3, target: 4, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    FileDetailsModifiedPupilsTable: function () {
        $(document).ready(function () {
            $('.modified-pupils-table')?.DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'.modified-pupils-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' }, //UPN
                    { responsivePriority: 1, target: 1, className: 'all' }, //Name
                    { responsivePriority: 3, target: 2, className: 'min-tablet-p' }, //Subject
                    { responsivePriority: 4, target: 3, className: 'min-tablet-p' }, //Old Result
                    { responsivePriority: 5, target: 4, className: 'min-tablet-p' }, // New Result
                    { responsivePriority: 6, target: 5, className: 'dtr-control', orderable: false, targets: -1 } //Expand
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    UploadsTable: function() {
        $(document).ready(function () {
            $('#upload-file-status-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this,'#upload-file-status-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 4, target: 1, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 2, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 3, target: 4, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },

    ManageWEDTable: function () {
        $(document).ready(function () {
            $('#manage-wed-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                autoWidth: false,
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 2, target: 0, className: 'all' },
                    { responsivePriority: 1, target: 1, className: 'all' },
                    { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 6, target: 4, className: 'min-tablet-l' },
                    { responsivePriority: 7, target: 5, className: 'min-tablet-l' },
                    { responsivePriority: 8, target: 6, className: 'min-tablet-l' },
                    { responsivePriority: 9, target: 7, className: 'min-tablet-l' },
                    { responsivePriority: 3, target: 8, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return (col.hidden && col.title != "\n                ") ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },
    AvailableIdpFilesTable: function (translations: {previousText: string, nextText: string, pageOfText: string}) {
        $(document).ready(async function () {
            // @ts-ignore
            if ($.fn.DataTable.isDataTable("#idps-table")) {
                return;
            }

            // @ts-ignore: Ensure rowCallback is the 5 argument method overload
            $('#idps-table').DataTable({
                dom: '<"top"t><"bottom"pi>', // reformatting layout of the datatable
                lengthChange: false,
                pageLength: PAGE_LIMIT,
                paging: true,
                searching: false,
                info: true,
                ordering: true,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this, '#idps-table');
                    let tableInfo = $('#idps-table').DataTable().page.info();
                    let modifiedPageOfText = translations.pageOfText;
                    let currentPage = tableInfo.page;

                    modifiedPageOfText = translations.pageOfText.replace('{0}', `${(tableInfo.page + 1)}`);
                    modifiedPageOfText = modifiedPageOfText.replace('{1}', `${tableInfo.pages}`)
                    $('#idps-table_info').html(modifiedPageOfText);

                    let selectAllCheckbox = $(`.available-idp-files-select-all-checkbox--${currentPage}`);
                    let fileCheckboxes = $(`.available-idp-files-checkbox--${currentPage}`);

                    bindSelectAllCheckboxToPagedList(selectAllCheckbox, fileCheckboxes, selectedIdpFilesToDownload);
                },
                // @ts-ignore: Ignore typing in rowCallback parameters
                rowCallback: function (row, _, _, displayIndex, _) {
                    let table = $('#idps-table').DataTable();
                    let tableInfo = table.page.info();
                    let currentPage = tableInfo.page;
                    let pageOfRow = Math.floor(displayIndex / PAGE_LIMIT);
                    let checkboxRow = $(row).find('td > input.available-idp-files-checkbox');
                    checkboxRow?.off('click');

                    if (currentPage == pageOfRow) {
                        checkboxRow.addClass(`available-idp-files-checkbox--${pageOfRow}`);
                    }
                },
                headerCallback: function (thead) {
                    let tableInfo = $('#idps-table').DataTable().page.info();
                    let currentPage = tableInfo.page;
                    let selectAllCheckbox = $(thead).find('th > input#available-idp-files-list__select-all-checkbox');
                    selectAllCheckbox?.removeClass();
                    selectAllCheckbox?.off('change');

                    selectAllCheckbox?.addClass(`available-idp-files-select-all-checkbox--${currentPage}`)
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all', orderable: false }, // Checkbox
                    { responsivePriority: 2, target: 1, className: 'all' }, // Filename
                    { responsivePriority: 5, target: 2, className: 'not-mobile' }, // Uploaded On
                    { responsivePriority: 4, target: 3, className: 'all' }, // Uploaded By
                    { responsivePriority: 3, target: 4, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + ':' + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                },
                language: {
                    paginate: {
                        previous: translations.previousText,
                        next: translations.nextText,
                        first: "",
                        last: ""
                    }
                }
            });
        });

        // Clear the selected files to download list every time the table refreshes; on page load, on download
        if (selectedIdpFilesToDownload.length > 0) {
            selectedIdpFilesToDownload = [];
        }
    },

    UploadIdpTable: function() {
        $(document).ready(function () {
            $('#idp-table').DataTable({
                lengthChange: false,
                paging: false,
                searching: false,
                info: false,
                ordering: true,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this, '#idp-table');
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all' },
                    { responsivePriority: 2, target: 1, className: 'all' },
                    { responsivePriority: 4, target: 2, className: 'min-tablet-l' },
                    { responsivePriority: 5, target: 3, className: 'min-tablet-l' },
                    { responsivePriority: 6, target: 4, className: 'min-tablet-l' },
                    { responsivePriority: 7, target: 5, className: 'all' },
                    { responsivePriority: 3, target: 6, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    '<td class="table__data-row--child">' + col.title + '</td> ' +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                }
            });
        })
    },
    DownloadedIdpFilesTable: function (translations: { previousText: string, nextText: string, pageOfText: string }) {
        $(document).ready(async function () {
            // @ts-ignore
            if ($.fn.DataTable.isDataTable("#downloaded-idps-table")) {
                return;
            }

            // @ts-ignore: Ensure rowCallback is the 5 argument method overload
            $('#downloaded-idps-table').DataTable({
                dom: '<"top"t><"bottom"pi>', // reformatting layout of the datatable
                lengthChange: false,
                pageLength: 10,
                paging: true,
                searching: false,
                info: true,
                ordering: true,
                autoWidth: false,
                drawCallback: function () {
                    hideDatatable(this, '#downloaded-idps-table');
                    let tableInfo = $('#downloaded-idps-table').DataTable().page.info();
                    let modifiedPageOfText = translations.pageOfText;
                    let currentPage = tableInfo.page;

                    modifiedPageOfText = translations.pageOfText.replace('{0}', `${(tableInfo.page + 1)}`);
                    modifiedPageOfText = modifiedPageOfText.replace('{1}', `${tableInfo.pages}`)
                    $('#downloaded-idps-table_info').html(modifiedPageOfText);

                    let selectAllCheckbox = $(`.downloaded-idp-files-select-all-checkbox--${currentPage}`);
                    let fileCheckboxes = $(`.downloaded-idp-files-checkbox--${currentPage}`);

                    bindSelectAllCheckboxToPagedList(selectAllCheckbox, fileCheckboxes, selectedDownloadedIdpFilesToUndo);
                },
                // @ts-ignore: Ignore typing in rowCallback parameters
                rowCallback: function (row, _, _, displayIndex, _) {
                    let table = $('#downloaded-idps-table').DataTable();
                    let tableInfo = table.page.info();
                    let currentPage = tableInfo.page;
                    let pageOfRow = Math.floor(displayIndex / PAGE_LIMIT);
                    let checkboxRow = $(row).find('td > input.downloaded-idp-files-checkbox');
                    checkboxRow?.off('change');

                    if (currentPage == pageOfRow) {
                        checkboxRow?.removeClass();
                        checkboxRow.addClass(`downloaded-idp-files-checkbox--${pageOfRow}`);
                    }
                },
                headerCallback: function (thead) {
                    let tableInfo = $('#downloaded-idps-table').DataTable().page.info();
                    let currentPage = tableInfo.page;
                    let selectAllCheckbox = $(thead).find('th > input#downloaded-idp-files-list__select-all-checkbox');
                    selectAllCheckbox?.removeClass();
                    selectAllCheckbox?.off('change');

                    selectAllCheckbox?.addClass(`downloaded-idp-files-select-all-checkbox--${currentPage}`)
                },
                // Set priority to columns
                // The lower the responsivePriority value the higher the priority
                // Target - column
                columnDefs: <any>[
                    { responsivePriority: 1, target: 0, className: 'all', orderable: false }, // Checkbox
                    { responsivePriority: 2, target: 1, className: 'all' }, // Filename
                    { responsivePriority: 5, target: 2, className: 'not-mobile' }, // Downloaded Date
                    { responsivePriority: 4, target: 3, className: 'not-mobile' }, // Downloaded By
                    { responsivePriority: 3, target: 4, className: 'dtr-control', orderable: false, targets: -1 }
                ],
                responsive: {
                    details: {
                        type: 'column',
                        target: -1,
                        // TypeScript is throwing an error, even though it still works when ignoring the error
                        // Renderer - how the expanded section is displayed
                        // @ts-ignore
                        renderer: function (api, rowIdx, columns) {
                            const data = $.map(columns, function (col, i) {
                                // Markup of how the expanded section is rendered
                                return col.hidden ?
                                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                                    (col.title ? '<td class="table__data-row--child">' + col.title + ':' + '</td> ' : '') +
                                    '<td class="table__data-row--child">' + col.data + '</td>' +
                                    '</tr>' :
                                    '';
                            }).join('');

                            return data ?
                                $('<table/>').append(data) :
                                false;
                        }
                    }
                },
                language: {
                    paginate: {
                        previous: translations.previousText,
                        next: translations.nextText,
                        first: "",
                        last: ""
                    }
                }
            });
        });

        // Clear the selected files to download list every time the table refreshes; on page load, on download
        if (selectedDownloadedIdpFilesToUndo.length > 0) {
            selectedDownloadedIdpFilesToUndo = [];
        }
    }
}

//Hides the specified column of the specified datatable
function hideColumn(mediaQuery: string, tableId: HTMLElement | null, column: ColumnSelector) {
    if (tableId != null) {
        if (window.matchMedia(mediaQuery).matches) {
            $(tableId).DataTable().column(column).visible(true);
        }
        else {
            $(tableId).DataTable().column(column).visible(false);
        }
    }
}

// @ts-ignore
function hideDatatable(config: Config, datatable: string) {
    const api = config.api();
    const numberOfRows = api.page.info().recordsTotal;

    if (numberOfRows == 0) {
        $(datatable).hide();
    }
}

/**
 * Get current selected IDP files to download
 */
export function getSelectedIdpFilesToDownload(): string[] {
    return selectedIdpFilesToDownload;
}

/**
* Get current selected downloaded IDP files to undo
*/
export function getSelectedDownloadedIdpFilesToUndo(): string[] {
    return selectedDownloadedIdpFilesToUndo;
}
